<template>
  <app-view>
    <html-content :value="value.content"></html-content>
  </app-view>
</template>
<script>
  import AppView from '../components/AppView.vue'
  import HtmlContent from '../components/HtmlContent.vue'

  export default {
    components: {AppView, HtmlContent},
    data () {
      return {
        value: {}
      }
    },
    computed: {
      id () {
        return this.$route.params.id
      }
    },
    async mounted () {
      this.value = await this.$service.news.loadDetail(this.id)
    }
  }
</script>
<style scoped lang='scss'>
  .view {
    padding: $app-padding;
    background-color: $color-white;
  }
</style>



// WEBPACK FOOTER //
// Detail.vue?51cc4536